import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Radio } from '@thd-olt-component-react/checkbox';
import { ProductResultsContext } from '../ProductResultsContext';
import '../../styles/lca-selector.scss';

const LCASelector = (props) => {
  const { data } = useContext(ProductResultsContext);

  if (!data) return null;
  const dimensions = data?.searchModel?.dimensions || {};
  const categoryDimensionRefinements = dimensions?.filter((dimension) => {
    return dimension?.label === 'Category';
  })?.[0]?.refinements;

  const { onSortChange, type, pageType, currentPage } = props;

  const handleLCASelection = useCallback((refinement) => {
    onSortChange({
      sortby: type.sortby,
      sortorder: type.sortorder,
      name: type.name,
      currentPage,
      page: pageType,
      updatedPath: refinement?.url
    });
  }, []);

  const getRefinementLabel = (refinement) => {
    const recordCount = `(${refinement.recordCount})`;
    return `${refinement.label} ${refinement.recordCount ? recordCount : null}`;
  };

  return (
    <div className="lca-selector" data-testid="lca-selector">
      {categoryDimensionRefinements?.map((refinement, index) => {
        return (
          <Radio
            key={refinement?.refinementKey}
            id={refinement?.refinementKey}
            onChange={() => { handleLCASelection(refinement); }}
            value={refinement?.label}
          >
            { getRefinementLabel(refinement) }
          </Radio>
        );
      })}
    </div>
  );
};

LCASelector.displayName = 'LCASelector';

LCASelector.propTypes = {
  onSortChange: PropTypes.func.isRequired,
  type: PropTypes.shape({
    name: PropTypes.string,
    sortby: PropTypes.string,
    sortorder: PropTypes.string
  }).isRequired,
  pageType: PropTypes.string.isRequired,
  currentPage: PropTypes.number.isRequired,
};

export { LCASelector };
